import React from "react";
import {
  PeopleOutline,
  ReturnUpBackOutline,
  CartOutline,
  ReceiptOutline,
  LogOutOutline,
  ReorderFourOutline,
  ArrowBackCircle,
} from "react-ionicons";
import stylesASAP from "./stylesASAP";
import {
  FcManager,
  FcBarChart,
  FcBullish,
  FcBearish,
  FcCalendar,
  FcComboChart,
  FcSurvey,
  FcSalesPerformance,
  FcNews,
  FcSynchronize,
  FcCancel,
  FcShop,
  FcRedo,
  FcProcess,
  FcRefresh,
  FcNook,
  FcShipped,
  FcPaid,
} from "react-icons/fc";

export default class Journal extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  async componentDidMount() {}
  arrowback = () => {
    this.props.history.push("./LandingPage");
  };
  SalesOrder = () => {
    localStorage.setItem("OrderType", JSON.stringify(0));
    localStorage.setItem("TransactionType", JSON.stringify(0));
    this.props.history.push("/UnsyTrans");
  };
  Return = () => {
    localStorage.setItem("OrderType", JSON.stringify(1));
    localStorage.setItem("TransactionType", JSON.stringify(1));
    this.props.history.push("/UnsyTrans");
  };
  Cash = () => {
    localStorage.setItem("OrderType", JSON.stringify(2));
    localStorage.setItem("TransactionType", JSON.stringify(5));
    this.props.history.push("/UnsyTrans");
  };
  Receipt = () => {
    localStorage.setItem("OrderType", JSON.stringify(3));
    localStorage.setItem("TransactionType", JSON.stringify(3));
    this.props.history.push("/UnsyTrans");
  };
  render() {
    return (
      <div className="container-fluid vh-100" style={stylesASAP.mainContainer}>
        <div className="pt-3">
          <ArrowBackCircle
            className="btn"
            onClick={() => this.arrowback()}
            color={"#00bfff"}
            height="50px"
            width="50px"
          />
        </div>
        <div>
          <p className="pt-2 text-center h1">Journals</p>
        </div>
        <div className="row mt-5 ">
          <div className="btn row Box-Shadow text-center m-2">
            <FcShop
              className="text-center"
              size={60}
              onClick={() => this.SalesOrder()}
            />

            <h4 className="card-text">Sales Order</h4>
          </div>
          <div className="btn row Box-Shadow text-center m-2">
            <FcProcess size={60} onClick={() => this.Return()} />

            <h4 className="card-text">Return Order</h4>
          </div>
          <div className="btn row Box-Shadow text-center m-2">
            <FcPaid
              className="text-center"
              size={60}
              onClick={() => this.Cash()}
            />

            <h4 className="card-text" >
              Cash Sales
            </h4>
          </div>
          <div className="btn row Box-Shadow text-center m-2">
            <FcNook
              className="text-center"
              size={60}
              onClick={() => this.Receipt()}
            />

            <h4 className="card-text" >
              Receipt
            </h4>
          </div>
        </div>
      </div>
    );
  }
}
